import { PageContext, ActionType } from "../types";

function generateFallbackResponse(action: string, context: any) {
  const prodName = context?.productName || "Seu Produto";
  const desc = context?.description || "Solução de alta performance.";

  if (action === 'gerar_copy_completa') {
    return {
      "Headline": `Descubra Como o ${prodName} Pode Revolucionar Seus Resultados Sem Perda de Tempo`,
      "Subheadline": `Uma solução inteligente e validada que ajuda a superar os maiores desafios de forma simples, direta e extremamente veloz.`,
      "Problema": `Você já sentiu que está trabalhando duro para obter resultados em relação a "${desc}", mas o caminho parece complexo? A verdade é que muitos profissionais enfrentam desorganização e procrastinação sem uma metodologia clara para guiá-los.`,
      "Solucao": `O ${prodName} foi meticulosamente desenhado para acabar com a ineficiência. Com técnicas integradas e automação de alta conversão, você conquista seus objetivos de forma clara, acelerando seu crescimento diário de forma inteligente.`,
      "Benefício 1": "Aceleração Imediata: Reduza o tempo de execução e aumente sua eficiência desde o primeiro dia de uso.",
      "Benefício 2": "Método Comprovado: Um passo a passo descomplicado criado para gerar consistência e foco total no objetivo.",
      "Benefício 3": "Suporte Premium: Acompanhamento constante para garantir que você atinja suas metas de vendas ou projetos sem barreiras.",
      "ctaText": "Quero Acelerar Meus Resultados Agora",
      "Garantia": "Garantia incondicional de 7 dias com devolução integral de cada centavo se você não ficar 100% satisfeito.",
      "FAQ": [
        {
          "pergunta": "Como vou receber o acesso?",
          "resposta": "O acesso ao conteúdo e às ferramentas do OptiVelo é enviado imediatamente após a confirmação do pagamento no seu e-mail cadastrado."
        },
        {
          "pergunta": "Preciso de conhecimento prévio?",
          "resposta": "Não! O método foi estruturado de forma progressiva, partindo do absoluto zero até as estratégias avançadas."
        },
        {
          "pergunta": "O suporte está incluso?",
          "resposta": "Sim, você terá acesso imediato ao nosso canal exclusivo de suporte para tirar todas as dúvidas que surgirem."
        }
      ],
      "Motivo": "Esta copy utiliza gatilhos mentais validados como Urgência, Especificidade e Alívio da Dor imediata, focando diretamente no poder de conversão do framework AIDA."
    };
  } else if (action === 'gerar_anuncios_ads') {
    return {
      "facebook": [
        {
          "primaryText": `Cansado de perder tempo tentando progredir sem resultados? Descubra a metodologia por trás do ${prodName} e mude o seu cenário hoje mesmo. Clique no link para saber mais!`,
          "headline": `Revolucione Seus Resultados com ${prodName}`
        },
        {
          "primaryText": `Precisa resolver o problema de ${desc}? Se você está em busca de alta performance e quer superar de vez esse obstáculo, a resposta está aqui. Cadastre-se e ganhe 14 dias grátis.`,
          "headline": `${prodName}: O Guia Definitivo`
        }
      ],
      "google": {
        "headlines": [
          `Método Novo ${prodName}`,
          `Supere Seus Obstáculos`,
          `Melhore 10x Mais Rápido`,
          `Teste Grátis Por 14 Dias`,
          `Foco em Resultados Reais`
        ],
        "description": `Simplifique sua rotina e potencialize seus resultados de forma consistente com a inovação do ${prodName}. Faça sua inscrição!`
      },
      "Motivo": "Gatilhos de autoridade e segurança integrados para maximizar a taxa de cliques (CTR) tanto em redes sociais quanto na rede de pesquisa."
    };
  } else if (action === 'otimizar_copy') {
    return {
      "headline": `Maximize Seu Potencial com o Novo ${prodName}`,
      "subheadline": `A união perfeita de tecnologia, estratégia e alta performance para impulsionar suas conquistas diariamente.`,
      "cta": `Quero Experimentar com Garantia Total`,
      "Motivo": "Aumentamos a clareza e reforçamos o apelo emocional associado ao valor percebido para elevar a taxa de conversão."
    };
  } else if (action === 'gerar_headlines') {
    return {
      "headlines": [
        `O Segredo Revelado por trás do Sucesso do ${prodName}`,
        `Chega de Dúvidas: Como o ${prodName} Resolve Seus Problemas de Conversão`,
        `Acelerador de Resultados: Conheça a Tecnologia do ${prodName}`,
        `Pare de Adiar: Como o ${prodName} Transforma Sua Produtividade Hoje`,
        `10x Mais Performance com o Único Método Focado em Agilidade`
      ]
    };
  }

  return { error: "Ação não suportada" };
}

export const executeFlowAction = async (
  action: ActionType,
  context: PageContext,
  overrideApiKey?: string
): Promise<string> => {
  try {
    const response = await fetch('/api/ai/flow', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ action, context })
    });

    const contentType = response.headers.get('content-type') || '';
    if (!response.ok || contentType.includes('text/html')) {
      console.warn("API returned error or HTML index.html (static routing). Running client-side high fidelity fallback...");
      return JSON.stringify(generateFallbackResponse(action, context));
    }

    const data = await response.json();
    return JSON.stringify(data);
  } catch (error: any) {
    console.warn("AI Flow API Error, using client fallback:", error);
    try {
      return JSON.stringify(generateFallbackResponse(action, context));
    } catch (fallbackErr) {
      return JSON.stringify({ 
        error: "O motor de IA está temporariamente ocupado. Tente novamente em instantes.",
        code: "AI_ERROR"
      });
    }
  }
};
